import { ViewportScroller } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  constructor(private _viewportScroller: ViewportScroller) {}

  public getScrollPosition(): [number, number] {
    return this._viewportScroller.getScrollPosition();
  }

  public scrollToPosition(position: [number, number]): void {
    this._viewportScroller.scrollToPosition(position);
  }
}
